/**
 * Triggers the global Contact Modal to open.
 * Listened for in Layout.tsx
 */
export const openContactModal = () => {
    window.dispatchEvent(new Event('open-contact'));
};
